import React from 'react';
import { Link } from 'react-router-dom';
import './inserieren.css';
import DirectusSDK from '@directus/sdk-js';
import HeadlessConfig from '../config/headless';
import InserierenCompleted from '../components/inserieren_completed';

const client = new DirectusSDK();
client.login({
  url: HeadlessConfig.url,
  project: HeadlessConfig.project,
  email: HeadlessConfig.email,
  password: HeadlessConfig.password
});

export default class Inserieren extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._onChangeValue = this._onChangeValue.bind(this);

        this.state = {
            form_type: "angebot",
            angebot_labels: {
                number: "So viele Gäste können bei mir maximal unterkommen",
                gender: "Bevorzugtes Geschlecht des Gastes",
                kids: "Kinder erlaubt",
                pets: "Haustiere erlaubt",
                smoking: "Rauchen in der Wohnung",
                accessible: "Rollstuhlgerecht",
                type: "Schlafraum",
                sleeping: "Schlafgelegenheit",
                parking: "Parkplatz",
                walking: "Laufentfernung zur Tübinger Altstadt",
                walking_minutes: "Laufentfernung zur Tübinger Altstadt in Minuten (circa)",
                more_text: "Besonderheiten zur Unterkunft",
                title: "Titel zum Angebot"
            },
            gesuch_labels: {
                number: "So viele Personen ",
                gender: "Mein Geschlecht",
                kids: "Ich bringe Kinder mit",
                pets: "Ich bringe ein Haustier mit",
                smoking: "Ich würde gerne in der Gastunterkunft rauchen",
                accessible: "Ich brauche eine rollstuhlgerechte Unterkunft",
                type: "Ich brauche einen Schlafraum, der so ist",
                sleeping: "Ich brauche einen Schlafgelegenheit, die so ist",
                parking: "Ich brauche (nach Möglichkeit) einen Parkplatz",
                walking: "Die Unterkunft sollte in Laufentfernung zur Tübinger Altstadt sein",
                walking_minutes: "Die Laufentfernung zur Tübinger Altstadt sollte maximal Minuten betragen",
                title: "Titel zum Gesuch"
            },
            filled: {
                title: {
                    value: '',
                    error: false,
                    filled: false
                },
                name: {
                    value: '',
                    error: false,
                    filled: false
                },
                address: {
                    value: '',
                    error: false,
                    filled: false
                },
                zip: {
                    value: '',
                    error: false,
                    filled: false
                },
                city: {
                    value: '',
                    error: false,
                    filled: false
                },
                phone: {
                    value: '',
                    error: false,
                    filled: false
                },
                email: {
                    value: '',
                    error: false,
                    filled: false
                },
                about: {
                    value: '',
                    error: false,
                    filled: false
                },
                number: {
                    value: 1,
                    error: false,
                    filled: true
                },
                gender: {
                    value: '',
                    error: false,
                    filled: false
                },
                kids: {
                    value: '',
                    error: false,
                    filled: false
                },
                bike: {
                    value: '',
                    error: false,
                    filled: false
                },
                pets: {
                    value: '',
                    error: false,
                    filled: false
                },
                accessible: {
                    value: '',
                    error: false,
                    filled: false
                },
                type: {
                    value: '',
                    error: false,
                    filled: false
                },
                sleeping: {
                    value: '',
                    error: false,
                    filled: false
                },
                parking: {
                    value: '',
                    error: false,
                    filled: false
                },
                walking_minutes: {
                    value: '5',
                    error: false,
                    filled: false
                },
                more_text: {
                    value: '',
                    error: false,
                    filled: false
                }
            },
            completed: false 
        }
    }


    _onChangeValue(type, newValue) {
        let filled = false;   
        let error = false;
        if(type !== "more_text") {
            if(newValue.trim() !== "") {
                filled = true; 
                error = false;
            } else {
                error = true;
            }

            let newObj = {};
            newObj[type] = {
                value: newValue,
                error: error,
                filled: filled
            }

            this.setState({
                ...this.state,
                filled: {
                    ...this.state.filled,
                    ...newObj
                }
            });
        }
    }

    _onSubmit() {
        // Validierung der Daten 
        let withError = false;
        const items = this.state.filled;
        const state = this.state;
        let newState = {};

        Object.keys(items).forEach(function (key) {
            if(items[key].filled === false) {
                if(key !== "more_text") {
                    if(state.form_type === "gesuch") {
                        if(
                            key !== "gender" &&
                            key !== "pets" && 
                            key !== "sleeping" && 
                            key !== "parking" && 
                            key !== "walking_minutes" && 
                            key !== "bike" && 
                            key !== "type"
                        ) {
                            withError = true;
                            newState[key] = {
                                ...items[key],
                                error: true
                            }
                        } else {
                            newState[key] = items[key];
                        }
                    } else {
                        withError = true;
                        newState[key] = {
                            ...items[key],
                            error: true
                        }
                    }
                } else {
                    newState[key] = items[key];
                }
            } else {
                newState[key] = items[key];
            }
        });

        if(withError) {

            console.log("new State", newState);

            this.setState({
                ...this.state,
                filled: newState
            });

            return false;
        } else {
            let new_type = "bnb_angebote";
            let inserat_typ = 0;
            if(this.state.form_type === "gesuch") {
                new_type = "bnb_gesuche"
                inserat_typ = 1;
            }

            client.createItem('bnb_angebote', {
                status: 'published',
                inserat_typ: inserat_typ,
                headline: this.state.filled.title.value,
                about: this.state.filled.about.value,
                number: this.state.filled.number.value,
                pets: this.state.filled.pets.value,
                accessible: this.state.filled.accessible.value,
                residential_type: this.state.filled.type.value,
                sleeping_accommodation: this.state.filled.sleeping.value,
                parking: this.state.filled.parking.value,
                walking_minutes: this.state.filled.walking_minutes.value,
                bike: this.state.filled.bike.value,
                active: 1,
                published: 1,
                gender: this.state.filled.gender.value,
                kids: this.state.filled.kids.value,
                more_text: this.state.filled.more_text.value,
                name: this.state.filled.name.value,
                address: this.state.filled.address.value,
                zip: this.state.filled.zip.value,
                city: this.state.filled.city.value,
                phone: this.state.filled.phone.value,
                email: this.state.filled.email.value
            }).then((data) => {
                console.log("success data", data);

                client.createItem('bnb_mailer', {
                    status: 'published',
                    mail_type: 3,
                    inserat_id: data.data.id,
                    inserat_type: inserat_typ,
                    email_to: this.state.filled.email.value,
                    email_from: 'unterkunft@worthaus.org'
                }).then((data) => {
                    window.location.href = "/homestay/danke/";
                }).catch((err) => {
                    window.location.href = "/homestay/fehler/";
                });
            }).catch((err) => {
                window.location.href = "/homestay/fehler/";
            });
        }
    }

    render() {

        let labels = this.state.angebot_labels;

        if(this.state.form_type === "angebot") {
            labels = this.state.angebot_labels;
        } else {
            labels = this.state.gesuch_labels;
        }

        return (
            <div className={'inserieren_wrapper'}>
                {this.state.completed && <InserierenCompleted />}
                {!this.state.completed && 
                <div className={'inserieren_wrapper_inner'}>
                    <div className={'inserieren_wrapper_inner_header'}>
                        <div className={'type_switcher'}>
                            <div className={(this.state.form_type === "angebot" ? 'active' : '')} onClick={() => {this.setState({form_type: "angebot"})}}><strong>Angebot</strong></div>
                            <div className={(this.state.form_type === "gesuch" ? 'active' : '')} onClick={() => {this.setState({form_type: "gesuch"})}}><strong>Gesuch</strong></div>
                        </div>
                        <Link to="/" className={'go_back_link'}>Zurück zur Übersicht</Link>
                    </div>
                    <div className={'form_container'}>
                        <h3>Persönliche Daten <small>Werden nicht veröffentlicht</small></h3>
                        <div>
                            <label>Vor- und Nachname *</label>
                            {this.state.filled.name.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                            <input type="text" value={this.state.filled.name.value} onChange={(e) => {this._onChangeValue('name', e.target.value)}} />
                        </div>
                        <div>
                            <label>Straße & Hausnummer *</label>
                            {this.state.filled.address.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                            <input type="text" value={this.state.filled.address.value} onChange={(e) => {this._onChangeValue('address', e.target.value)}} />
                        </div>
                        <div className={'half_width'}>
                            <div>
                                <label>Plz *</label>
                                {this.state.filled.zip.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                                <input type="text" value={this.state.filled.zip.value} onChange={(e) => {this._onChangeValue('zip', e.target.value)}} />
                            </div>
                            <div>
                                <label>Ort *</label>
                                {this.state.filled.city.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                                <input type="text" value={this.state.filled.city.value} onChange={(e) => {this._onChangeValue('city', e.target.value)}} />
                            </div>
                        </div>
                        <div>
                            <label>Telefon *</label>
                            {this.state.filled.phone.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                            <input type="text" value={this.state.filled.phone.value} onChange={(e) => {this._onChangeValue('phone', e.target.value)}} />
                        </div>
                        <div>
                            <label>E-Mail *</label>
                            {this.state.filled.email.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                            <input type="email" value={this.state.filled.email.value} onChange={(e) => {this._onChangeValue('email', e.target.value)}} />
                        </div>
                    </div>



                    <div className={'form_container'}>

                        <h3>Informationen zum {this.state.form_type === "angebot" && "Angebot"}{this.state.form_type === "gesuch" && "Gesuch"}</h3>

                        <div>
                            <label>{labels.title} *</label>
                            {this.state.filled.title.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                            <input type="text" value={this.state.filled.title.value} onChange={(e) => {this._onChangeValue('title', e.target.value)}} />
                        </div>

                        <div>
                            <label>Über mich/uns *</label>
                            {this.state.filled.about.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                            <textarea value={this.state.filled.about.value} onChange={(e) => {this._onChangeValue('about', e.target.value)}} ></textarea>
                        </div>
                        <div>
                            <label>{labels.number} *</label>
                            {this.state.filled.number.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                            <select value={this.state.filled.number.value} onChange={(e) => {this._onChangeValue('number', e.target.value)}} className={'bnb_select'}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">Mehr als 10</option>
                            </select>
                        </div>
                        <section className={`form_grid`}>
                            {this.state.form_type === "angebot" && 
                                <div className={`grid_inner ${(this.state.filled.gender.error) ? 'error' : ''}`}>
                                    <label>{labels.gender} *</label>
                                    <div className="radio_container"><input type="radio" id="gender_0" value="0" checked={this.state.filled.gender.value === '0'} onChange={(e) => {this._onChangeValue('gender', e.target.value)}} /><label htmlFor="gender_0">Weiblich</label></div>
                                    <div className="radio_container"><input type="radio" id="gender_1" value="1" checked={this.state.filled.gender.value === '1'} onChange={(e) => {this._onChangeValue('gender', e.target.value)}} /><label htmlFor="gender_1">Männlich</label></div>
                                    <div className="radio_container"><input type="radio" id="gender_2" value="2" checked={this.state.filled.gender.value === '2'} onChange={(e) => {this._onChangeValue('gender', e.target.value)}} /><label htmlFor="gender_2">Egal</label></div>
                                </div>
                            }
                            <div className={`grid_inner ${(this.state.filled.kids.error) ? 'error' : ''}`}>
                                <label>{labels.kids} *</label>
                                <div className="radio_container"><input type="radio" id="kids_0" value="0" checked={this.state.filled.kids.value === '0'} onChange={(e) => {this._onChangeValue('kids', e.target.value)}} /><label htmlFor="kids_0">Nein</label></div>
                                <div className="radio_container"><input type="radio" id="kids_1" value="1" checked={this.state.filled.kids.value === '1'} onChange={(e) => {this._onChangeValue('kids', e.target.value)}} /><label htmlFor="kids_1">Ja</label></div>
                            </div>
                            {this.state.form_type === "angebot" &&
                                <div className={`grid_inner ${(this.state.filled.pets.error) ? 'error' : ''}`}>
                                    <label>{labels.pets} *</label>
                                    <div className="radio_container"><input type="radio" id="pets_0" value="0" checked={this.state.filled.pets.value === '0'} onChange={(e) => {this._onChangeValue('pets', e.target.value)}} /><label htmlFor="pets_0">Nein</label></div>
                                    <div className="radio_container"><input type="radio" id="pets_1" value="1" checked={this.state.filled.pets.value === '1'} onChange={(e) => {this._onChangeValue('pets', e.target.value)}} /><label htmlFor="pets_1">Ja</label></div>
                                </div>
                            }
                            {this.state.form_type === "angebot" &&
                                <div className={`grid_inner ${(this.state.filled.bike.error) ? 'error' : ''}`}>
                                    <label>Fahrrad ausleihbar *</label>
                                    <div className="radio_container"><input type="radio" id="bike_0" value="0" checked={this.state.filled.bike.value === '0'} onChange={(e) => {this._onChangeValue('bike', e.target.value)}} /><label htmlFor="bike_0">Nein</label></div>
                                    <div className="radio_container"><input type="radio" id="bike_1" value="1" checked={this.state.filled.bike.value === '1'} onChange={(e) => {this._onChangeValue('bike', e.target.value)}} /><label htmlFor="bike_1">Ja</label></div>
                                </div>
                            }
                            <div className={`grid_inner ${(this.state.filled.accessible.error) ? 'error' : ''}`}>
                                <label>{labels.accessible} *</label>
                                <div className="radio_container"><input type="radio" id="accessible_0" value="0" checked={this.state.filled.accessible.value === '0'} onChange={(e) => {this._onChangeValue('accessible', e.target.value)}} /><label htmlFor="accessible_0">Nein</label></div>
                                <div className="radio_container"><input type="radio" id="accessible_1" value="1" checked={this.state.filled.accessible.value === '1'} onChange={(e) => {this._onChangeValue('accessible', e.target.value)}} /><label htmlFor="accessible_1">Ja</label></div>
                            </div>
                            {this.state.form_type === "angebot" &&
                            <div className={`grid_inner ${(this.state.filled.type.error) ? 'error' : ''}`}>
                                <label>{labels.type} *</label>
                                <div className="radio_container"><input type="radio" id="type_0" value="0" checked={this.state.filled.type.value === '0'}  onChange={(e) => {this._onChangeValue('type', e.target.value)}} /><label htmlFor="type_0">Geteiltes Zimmer</label></div>
                                <div className="radio_container"><input type="radio" id="type_1" value="1" checked={this.state.filled.type.value === '1'}  onChange={(e) => {this._onChangeValue('type', e.target.value)}} /><label htmlFor="type_1">eigener Raum in einer Wohnung</label></div>
                                <div className="radio_container"><input type="radio" id="type_2" value="2" checked={this.state.filled.type.value === '2'}  onChange={(e) => {this._onChangeValue('type', e.target.value)}} /><label htmlFor="type_2">eigene Wohnung</label></div>
                            </div>
                            }
                            {this.state.form_type === "angebot" && 
                                <div className={`grid_inner ${(this.state.filled.sleeping.error) ? 'error' : ''}`}>
                                    <label>{labels.sleeping} *</label>
                                    <div className="radio_container"><input type="radio" id="sleeping_0" value="0" checked={this.state.filled.sleeping.value === '0'} onChange={(e) => {this._onChangeValue('sleeping', e.target.value)}} /><label htmlFor="sleeping_0">Einzel-Bett</label></div>
                                    <div className="radio_container"><input type="radio" id="sleeping_1" value="1" checked={this.state.filled.sleeping.value === '1'} onChange={(e) => {this._onChangeValue('sleeping', e.target.value)}} /><label htmlFor="sleeping_1">Doppel-Bett</label></div>
                                    <div className="radio_container"><input type="radio" id="sleeping_2" value="2" checked={this.state.filled.sleeping.value === '2'} onChange={(e) => {this._onChangeValue('sleeping', e.target.value)}} /><label htmlFor="sleeping_2">Couch</label></div>
                                    <div className="radio_container"><input type="radio" id="sleeping_3" value="3" checked={this.state.filled.sleeping.value === '3'} onChange={(e) => {this._onChangeValue('sleeping', e.target.value)}} /><label htmlFor="sleeping_3">Matratze auf dem Boden</label></div>
                                    <div className="radio_container"><input type="radio" id="sleeping_4" value="4" checked={this.state.filled.sleeping.value === '4'} onChange={(e) => {this._onChangeValue('sleeping', e.target.value)}} /><label htmlFor="sleeping_4">Das was Du Dir mitbringst</label></div>
                                </div>
                            }
                            {this.state.form_type === "angebot" && 
                                <div className={`grid_inner ${(this.state.filled.parking.error) ? 'error' : ''}`}>
                                    <label>{labels.parking} *</label>
                                    <div className="radio_container"><input type="radio" id="parking_0" value="0" checked={this.state.filled.parking.value === '0'} onChange={(e) => {this._onChangeValue('parking', e.target.value)}} /><label htmlFor="parking_0">Nein</label></div>
                                    <div className="radio_container"><input type="radio" id="parking_1" value="1" checked={this.state.filled.parking.value === '1'} onChange={(e) => {this._onChangeValue('parking', e.target.value)}} /><label htmlFor="parking_1">Ja</label></div>
                                </div>
                            }
                        </section>
                        {this.state.form_type === "angebot" &&
                            <div>
                                <label>{labels.walking_minutes} *</label>
                                {this.state.filled.walking_minutes.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                                <select value={this.state.filled.walking_minutes.value} onChange={(e) => {this._onChangeValue('walking_minutes', e.target.value)}} className={'bnb_select'}>
                                    <option value="5">5 Minuten</option>
                                    <option value="10">10 Minuten</option>
                                    <option value="20">20 Minuten</option>
                                    <option value="30">30 Minuten</option>
                                    <option value="45">45 Minuten</option>
                                    <option value="60">60 Minuten</option>
                                    <option value="0">Mehr</option>
                                </select>
                            </div>
                        }
                        {this.state.form_type === "angebot" && 
                            <div>
                                <label>Besonderheiten zur Unterkunft</label>
                                <textarea value={this.state.filled.more_text.value} onChange={(e) => {this._onChangeValue('more_text', e.target.value)}}></textarea>
                            </div>
                        }

                        <div>
                            <p className={'requiredNote'}>* Pflichtfeld</p>
                        </div>

                        <div>
                            <div className={'inserieren_submit'} onClick={this._onSubmit}>
                                {this.state.form_type === "angebot" && "Angebot"}
                                {this.state.form_type === "gesuch" && "Gesuch"} einstellen
                            </div>
                        </div>
                    </div>  
                </div>
                }
            </div>
        )
    }
}